import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../../TablePagination';

import {useContext} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useState} from 'react';
import Spinner from '../../../../components/Spinner';
import {getLeadsFollowUp} from '../../../../pages/requests';
import NotFound from '../../../NotFound';
import moment from 'moment';

import ChartOne from './ChartOne';

// import { Container } from './styles';

function TableLeads() {
    const {t} = useTranslation();

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const [loading, setLoading] = useState(true);

    const {isCard, openCards} = useContext(Context);

    const FORMATO_DATA = 'YYYY-MM-DD';

    const [leads, setLeads] = useState([]);

    const [isMobile, setIsMobile] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalLinhas, setTotalLinhas] = useState(0);
    const [semDados, setSemDados] = useState(false);

    const ITEMS_PER_PAGE = 15;

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        promises.push(
            getLeadsFollowUp(lang, indexOfFirstItem, indexOfLastItem).then(res => {
                if (res.data.success) {
                    setLeads(res.data.leads);
                    setTotalLinhas(res.data.totalLeads);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <>
            <div className="grid grid-cols-1 lg:grid-cols-2 py-4 gap-4">
                <div>
                    <div>
                        {isMobile || isCard ? (
                            <div>
                                <div className="flex dark:bg-gray-600 rounded-t-[8px] bg-gray-100  flex-wrap items-center px-4 py-2">
                                    <div className="relative  w-full max-w-full flex-grow flex-1 ">
                                        <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('leadsFollowUp')}</h3>
                                    </div>
                                </div>
                                {leads?.map((dados, index) => (
                                    <>
                                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                            <h2 className="mb-0" id="headingOne">
                                                <button
                                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                                    type="button"
                                                    data-te-collapse-init
                                                    data-te-collapse-collapsed
                                                    data-te-target={'#flush-collapseThreeLeads' + index}
                                                    aria-expanded="false"
                                                    aria-controls="flush-collapseThree">
                                                    <div className="flex flex-row">
                                                        {dados.nomeEmpresa} | {dados.interesse} | {moment(dados.dataFollowUp).format(FORMATO_DATA)}
                                                    </div>
                                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                                        </svg>
                                                    </span>
                                                </button>
                                            </h2>
                                            <div
                                                id={'flush-collapseThreeLeads' + index}
                                                className={openCards ? 'visible' : '!visible hidden'}
                                                data-te-collapse-item
                                                aria-labelledby="flush-headingThree"
                                                data-te-parent="#accordionFlushExample">
                                                <div className="px-5 py-4">
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('razaoSocial')}:</div> {dados.nomeEmpresa}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('interesse')}: </div> {dados.interesse}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('equipamento')}: </div> {dados.equipamento}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('dataFollowUp')}: </div> {moment(dados.dataFollowUp).format(FORMATO_DATA)}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('dias')}: </div> {dados.dias}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ))}

                                {semDados && !loading && <NotFound frase={t('semRegistos')} />}

                                {loading && (
                                    <div className="flex flex-row mt-14 justify-center">
                                        <>
                                            <Spinner />
                                        </>
                                    </div>
                                )}

                                <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                                    <div>
                                        <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                            {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                            <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                        </span>

                                        <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                        <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                                    </div>
                                    {totalLinhas != 0 && <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                                </nav>
                            </div>
                        ) : (
                            <div className="relative min-h-[415px] overflow-x-auto shadow-md sm:rounded-[8px]">
                                <div className="flex dark:bg-gray-600  flex-wrap items-center px-4 py-2">
                                    <div className="relative  w-full max-w-full flex-grow flex-1 ">
                                        <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('leadsFollowUp')}</h3>
                                    </div>
                                </div>
                                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 w-72">
                                                {t('razaoSocial')}
                                            </th>

                                            <th scope="col" className="px-6 py-3">
                                                {t('interesse')}
                                            </th>

                                            <th scope="col" className="px-6 py-3">
                                                {t('equipamentos')}
                                            </th>
                                            <th scope="col" className="px-6 py-3">
                                                {t('dataFollowUp')}
                                            </th>

                                            <th scope="col" className=" py-3">
                                                {t('dias')}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {leads?.map(dados => {
                                            return (
                                                <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                        {dados.nomeEmpresa}
                                                    </th>

                                                    <td className="px-6 py-1 w-74">{dados.interesse}</td>

                                                    <td className="px-6 py-1">{dados.equipamento}</td>

                                                    <td className=" py-1">{moment(dados.dataFollowUp).format(FORMATO_DATA)}</td>

                                                    <td className=" py-1">{dados.dias}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                {semDados && !loading && <NotFound frase={t('semRegistos')} />}

                                {/* {totalLinhas === undefined && (
                        <NotFound frase={t('naoExistemClientes')} />
                    )} */}

                                {loading && (
                                    <div className="flex flex-row mt-14 justify-center">
                                        <>
                                            <Spinner />
                                        </>
                                    </div>
                                )}
                                <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                                    <div>
                                        <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                            {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                            <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                        </span>

                                        <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                        <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                                    </div>
                                    {totalLinhas != 0 && <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                                </nav>
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <ChartOne />
                </div>
            </div>
        </>
    );
}

export default TableLeads;
